import _ from 'lodash'
import smoothscroll from 'smoothscroll-polyfill'
import Config from '../configs'
smoothscroll.polyfill()

export default function scrollIntoView(props) {
  const { target = null, behavior = 'smooth', block = 'start', delay = 0 } = props || {}
  const page_anchor = document.getElementById(Config.get('PAGE_TOP_ANCHOR_ID')) || document.documentElement
  let element = !_.isEmpty(target) && _.isString(target)
    ? _.head(document.querySelectorAll(target))
    : !_.isEmpty(target) && _.isElement(target)
      ? target
      : page_anchor

  if (!_.isEmpty(element)) {
    setTimeout( () => {
      try {
        // element.scrollIntoView({ behavior, block })
        // Sometimes the scroll doesn't fire so need to fire later to be sure!
        // TODO: Find a proper fix without resorting to set timeout.
        element.scrollIntoView({ behavior, block })
      } catch (ex) {
        if (ex instanceof TypeError) {
          // Firefox less than version 58 does not support block='center' with exception error:
          //   "'block' member of ScrollIntoViewOptions 'center' is not a valid value for enumeration ScrollLogicalPosition."
          if (/ScrollIntoViewOptions/.test(ex.message)) {
            element.scrollIntoView({ behavior, block: 'start' })
          }
        }
      }
    }, delay)
  } else {
    // page_anchor.scrollIntoView({ behavior, block: 'start' })
    // Sometimes the scroll doesn't fire so need to fire later to be sure!
    // TODO: Find a proper fix without resorting to set timeout.
    setTimeout( () => page_anchor.scrollIntoView({ behavior, block: 'start' }), delay)
  }
}



// WEBPACK FOOTER //
// ./src/lib/scrollIntoView.js